export class Standortgruppe {
  constructor({
    id,
    istRotationsplanAktiviert,
  }: {
    id: string;
    istRotationsplanAktiviert: boolean;
  }) {
    this.id = id;
    this.istRotationsplanAktiviert = istRotationsplanAktiviert;
  }

  id: string;
  istRotationsplanAktiviert: boolean;
}
